import React, { Component } from 'react'
import { Checkbox, DatePicker, Modal } from 'antd'
import moment from 'moment'
import _ from 'lodash'

export default class IrreversibleModalConfirmCheckbox extends Component {
    constructor(props) {
        super(props)

        this.state = {
            paidDate: moment()
        }
    }

    render() {
        const { checked, disabled, fieldName, onChange } = this.props
        const popConfirmMessage = fieldName !== 'paid' ?
            'This action is irreversible, are you sure?' :
            (
                <div>
                    <p>This action is irreversible, are you sure?</p>
                    <span>Paid at: </span>
                    <DatePicker
                        defaultValue={moment()}
                        onChange={(date, dateString) => this.setState({ paidDate: date })}
                    />
                </div>
            )

        return (
            <Checkbox
                checked={checked}
                disabled={disabled}
                onChange={(e) => Modal.confirm({
                        title: 'Confirm',
                        content: popConfirmMessage,
                        okText: 'Yes',
                        onOk: () => onChange(this.state.paidDate),
                        onCancel: () => {}
                    })
                }
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/Commons/IrreversibleModalConfirmCheckbox/IrreversibleModalConfirmCheckbox.js